type MessageSorts = "Hello" | "Image" | "Barcode" | "Ping";
interface IMessage {
    sort: MessageSorts;
}
class PingMessage 
    implements IMessage {
    
    public sort: MessageSorts;

    constructor() {
        this.sort = "Ping";
    }
}
class ImageMessage
    implements IMessage {

    public sort: MessageSorts;
    public fileName?: string;
    public image?: string;

    constructor() {
        this.sort = "Image";
    }
}
class BarcodeMessage
    implements IMessage {

    public sort: MessageSorts;
    public barcode?: string;

    constructor() {
        this.sort = "Barcode";
    }
}
class HelloMessage
    implements IMessage {

    public sort: MessageSorts;
    public message?: string;

    constructor() {
        this.sort = "Hello";
    }
}

class LocalService {
    private _webSocket: WebSocket | undefined;
    private _pingTimeout: number | undefined;
    private readonly _trigger : IQueryTriggerEventAsync<IMessage>;

    constructor(trigger : IQueryTriggerEventAsync<IMessage>) {
        this._trigger = trigger;

        try {
            this.poll();
        } catch {
            console.log("Allow insecure content if on picture booth");
        }
    }

    private poll() {
        let that = this;
        this._webSocket = new WebSocket("ws://local.easyflor.eu:37777/");
        this._webSocket.onclose = function(event: CloseEvent) {
            window.setTimeout(() => that.poll(), 5000);
            console.log("WS: Connection closed. Will retry in 5 seconds.");
        }
        this._webSocket.onmessage = function(event: MessageEvent) {
            try {
                let deserialized = QueryJSON.deserialize<IMessage>(event.data);
                if (deserialized != null) {
                    let casted = QueryJSON.cast<IMessage>(that.getType(deserialized), deserialized);
                    if (casted instanceof PingMessage)
                    {
                        that.pingReceived();
                    }
                    else
                    {
                        that._trigger.trigger(casted);
                    }
                }
            } catch(e) {
                console.log(e);
            }
        }
        this._webSocket.onopen = function(event: Event) {
            console.log("WS: Connection opened.");
            
            let test = new HelloMessage();
            test.message = "1.0";
            that.send(test);
        }
    }

    private pingReceived()
    {
        if (this._pingTimeout != null)
            window.clearTimeout(this._pingTimeout);
        this._pingTimeout = window.setTimeout(() => this.close(), 15 * 1000);
    }

    private getType(eventData: IMessage) {
        switch (eventData.sort) {
            default:
                return HelloMessage;
            case "Ping":
                return PingMessage;
            case "Image":
                return ImageMessage;
            case "Barcode":
                return BarcodeMessage;
        }
    }

    private send(message: any) {
        let toSend = JSON.stringify(message);

        if(this._webSocket != null)
            this._webSocket.send(toSend);
    }
    private close() {
        if(this._webSocket != null)
            this._webSocket.close();
        console.log("WS: Connection closing.");
    }
}